import { render } from "./ComponentStarredNoData.vue?vue&type=template&id=c0557144"
import script from "./ComponentStarredNoData.vue?vue&type=script&lang=js"
export * from "./ComponentStarredNoData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__